import { Link as RouterLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { disabledFilter, textEllipsis } from '../helpers/styled'
import { Title } from '../jobs/JobTitle'
import { Param as JobLayoutParam, RowLink as JobRowLink } from '../printers/overview/JobLayout'
import { Label as ParamsLabel, Value as ParamsValue } from '../printers/overview/styled'
import { PlainButton } from './PlainButton'

const getItemStyle = (disabled?: boolean) => css`
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  ${disabledFilter(!!disabled)};
  cursor: pointer;
  color: black;

  &:hover {
    color: black;
    background: rgba(0, 0, 0, 0.05);
  }

  svg {
    height: 16px;
    width: 16px;
    margin-right: 0.5rem;
  }
`

export const Params = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  ${textEllipsis};
`

export const Param = styled(JobLayoutParam)`
  min-width: 0;
`

export const Label = styled(ParamsLabel)`
  display: block;
  :first-letter {
    text-transform: uppercase;
  }
`

export const Value = styled(ParamsValue)`
  display: block;
  ${textEllipsis};
`

export const PrinterTitle = styled(Title)`
  font-size: 1.5rem;
`

export const RowLink = styled(JobRowLink)`
  border-left: 1px solid var(--border-secondary);
  border-bottom: none;
  gap: 0;
  height: 100%;
  padding: 10px;

  &:first-child {
    border-left: none;
  }

  &:hover {
    background: none;
    > div {
      background: none !important;
    }
  }

  &:hover ${PrinterTitle} {
    color: var(--color-primary) !important;
  }
`

export const Menu = styled.div`
  background: var(--background-secondary);
  border: 1px solid var(--border-secondary);
  color: #212529;
  padding: 1rem 3rem 0.5rem 1rem;
  text-align: left;
  z-index: 1000;
`

export const PrinterGrid = styled.div<{ $gridTemplateColumns: string }>`
  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
`

export const Item = styled.div<{ disabled?: boolean }>`
  ${(props) => getItemStyle(props.disabled)}
`

export const Link = styled(RouterLink)<{ disabled?: boolean }>`
  ${(props) => getItemStyle(props.disabled)}
`

export const ColImg = styled.div`
  min-width: 120px;
  max-width: 180px;
  flex-shrink: 0;
  flex-grow: 1;

  img {
    width: 100%;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  right: 18px;
`

export const ToggleButton = styled(PlainButton)`
  height: 100%;
  display: block;
`

export const Footer = styled.div`
  margin-top: 0.5em;
  padding-top: 0.5em;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-top: 1px solid var(--border-secondary);
  justify-content: center;
`

export const FooterTitle = styled.span`
  display: block;
  text-transform: uppercase;
  font-weight: 700;
  padding: 0 0.5em;
  font-size: 0.75rem;
  color: var(--color-text);
`
